import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    audioUploadModal: false,
    audioURL: '',
    isAudioUrlUploadModal: false,
    audioUploadProgressPercentage: 0,
    publishProgressPercentage: 0,
    previewFile: false,
    audioDetails: {
        file: {},
        name: '',
        length: 0,
        type: '',
        source: {},
    }
}

const audioCreateSlice = createSlice({
    name: 'Audios',
    initialState,
    reducers: {
        openAudioModal: (state, action) => {
            state.audioUploadModal = true;
        },
        audioUrlChanged: (state, action) => {
            state.audioURL = action.payload
        },
        openAudioUrlModal: (state, action) => {
            state.isAudioUrlUploadModal = true
        },
        resetAudioModalState: (state, action) => initialState,
        changePublishPercentage: (state, action) => {
            state.publishProgressPercentage = action.payload
        },
        changeAudioUploadProgressPercentage: (state, action) => {
            state.audioUploadProgressPercentage = action.payload
        },
        previewPublishedFile: (state, action) => {
            state.previewFile = true
        },
        addAudioDetails: (state, action) => {
            state.audioDetails = action.payload
        },
    }
});

const { actions, reducer } = audioCreateSlice;
export default reducer;
export const audioActions = actions;